import BatchDiffContent from '@/components/compare/batch-diff/batch-diff';

export default function BatchDiff() {
    return <BatchDiffContent />;
}
